import { NotFound } from '@/components';
import type { FC } from 'react';

import WorkflowLayout from '../layouts/WorkflowLayout';

const NotFoundPage: FC = () => {
  return (
    <WorkflowLayout>
      <NotFound />
    </WorkflowLayout>
  );
};

export default NotFoundPage;
